module.exports = __webpack_public_path__ + "poster/logo-poster.svg";